module.exports = __webpack_public_path__ + "img/sadpin.13028bdc.svg";